"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClaimRefBonuses = exports.useMyReferralStats = void 0;
const hooks_1 = require("@app/store/external/multicall/hooks");
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const translation_hooks_1 = require("@hooks/translation.hooks");
const core_1 = require("@web3-react/core");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const react_1 = require("react");
const contract_hooks_1 = require("./contract.hooks");
const useMyReferralStats = () => {
    const { account, chainId } = (0, core_1.useWeb3React)();
    const tokens = (0, tokens_reducer_1.useTokenListForCurrentChain)();
    const requestData = tokens.map(({ address }) => [account, address]);
    const referralHelperContract = (0, contract_hooks_1.useContract)("MCReferralHelper", chainId);
    const results = (0, hooks_1.useSingleContractMultipleData)(referralHelperContract, "tokenReferralInfo", requestData);
    return results.map(({ result }, index) => {
        const [paymentsTotal, , totalEarned, availableToClaim] = result || [];
        return {
            paymentsTotal: new bignumber_js_1.default((paymentsTotal === null || paymentsTotal === void 0 ? void 0 : paymentsTotal.toString()) || 0),
            totalEarned: new bignumber_js_1.default((totalEarned === null || totalEarned === void 0 ? void 0 : totalEarned.toString()) || 0),
            availableToClaim: new bignumber_js_1.default((availableToClaim === null || availableToClaim === void 0 ? void 0 : availableToClaim.toString()) || 0),
            token: tokens[index],
        };
    });
};
exports.useMyReferralStats = useMyReferralStats;
const useClaimRefBonuses = () => {
    const commandExecutor = (0, contract_hooks_1.useDefaultContractCallback)("MCReferralHelper", "claimBonusOfToken");
    const translator = (0, translation_hooks_1.useComponentTranslation)("txMessages");
    return (0, react_1.useCallback)((token) => __awaiter(void 0, void 0, void 0, function* () {
        const summary = translator("claimBonusOfToken", {
            symbol: token.symbol,
        });
        const promiseCallback = yield commandExecutor(summary, [token.address], "claimRefBonuses");
        return promiseCallback();
    }), [commandExecutor]);
};
exports.useClaimRefBonuses = useClaimRefBonuses;
